import logoThermfection from './Thermfection.png';
import industrialHero from './assets/industrial-hero.png';
import './App.css';

const services = [
  {
    eyebrow: 'CNC Machining',
    title: 'Precision parts from prototype through production',
    copy:
      'Tight-tolerance milling, turning, fixture work, repair components, and production-ready machined parts for demanding industrial environments.',
  },
  {
    eyebrow: 'Parts Supply',
    title: 'Automation components sourced with urgency',
    copy:
      'PLC hardware, HMI panels, drives, sensors, motion components, pneumatic parts, controls hardware, and hard-to-find replacement items.',
  },
  {
    eyebrow: 'Field Service',
    title: 'Practical support for uptime-critical equipment',
    copy:
      'Troubleshooting, panel support, controls upgrades, installation assistance, and maintenance planning for production and facility teams.',
  },
];

const capabilities = [
  'CNC milling and turning',
  'Fixture and tooling support',
  'Control panel components',
  'PLC, HMI, VFD, and servo supply',
  'Sensor and safety hardware',
  'Machine repair components',
  'Obsolete part sourcing',
  'Automation troubleshooting',
];

const process = [
  {
    step: '01',
    title: 'Review',
    copy: 'We examine drawings, BOMs, machine symptoms, timelines, and production requirements before recommending the right path.',
  },
  {
    step: '02',
    title: 'Source or Build',
    copy: 'Our team supplies the needed automation components, machines the required parts, or coordinates both for a complete solution.',
  },
  {
    step: '03',
    title: 'Support',
    copy: 'We help your maintenance, engineering, and purchasing teams move quickly from quote to installation and follow-up service.',
  },
];

function App() {
  return (
    <div className="site-shell">
      <header className="site-header" aria-label="Primary navigation">
        <a className="brand" href="#top" aria-label="Thermfection home">
          <img src={logoThermfection} alt="Thermfection" />
        </a>
        <nav className="nav-links" aria-label="Main menu">
          <a href="#services">Services</a>
          <a href="#capabilities">Capabilities</a>
          <a href="#contact">Contact</a>
        </nav>
        <a className="header-cta" href="#contact">
          Request a Quote
        </a>
      </header>

      <main id="top">
        <section className="hero" aria-labelledby="hero-title">
          <div className="hero-media" aria-hidden="true">
            <img src={industrialHero} alt="" />
          </div>
          <div className="hero-overlay" />
          <div className="hero-content">
            <p className="section-kicker">Industrial supply, machining, and service</p>
            <h1 id="hero-title">Built for the teams that keep production moving.</h1>
            <p className="hero-copy">
              Thermfection supports manufacturers with CNC machining, industrial automation
              parts supply, and hands-on service for equipment that cannot sit idle.
            </p>
            <div className="hero-actions" aria-label="Primary actions">
              <a className="button button-primary" href="#contact">
                Start an RFQ
              </a>
              <a className="button button-secondary" href="#services">
                View Services
              </a>
            </div>
            <div className="trust-row" aria-label="Company strengths">
              <span>Precision machining</span>
              <span>Automation components</span>
              <span>Uptime-focused service</span>
            </div>
          </div>
        </section>

        <section className="intro-band" aria-label="Company overview">
          <div className="intro-copy">
            <p className="section-kicker">Thermfection</p>
            <h2>A single industrial partner for parts, machining, and automation support.</h2>
          </div>
          <p>
            From replacement machine parts to control hardware and field troubleshooting,
            we help purchasing, maintenance, and engineering teams solve urgent production
            problems with a practical, accountable approach.
          </p>
        </section>

        <section className="section-block" id="services" aria-labelledby="services-title">
          <div className="section-heading">
            <p className="section-kicker">Core Services</p>
            <h2 id="services-title">Industrial capability without the runaround.</h2>
          </div>
          <div className="service-grid">
            {services.map((service) => (
              <article className="service-card" key={service.eyebrow}>
                <p>{service.eyebrow}</p>
                <h3>{service.title}</h3>
                <span>{service.copy}</span>
              </article>
            ))}
          </div>
        </section>

        <section className="capability-band" id="capabilities" aria-labelledby="capabilities-title">
          <div className="capability-copy">
            <p className="section-kicker">Capabilities</p>
            <h2 id="capabilities-title">Ready for sourcing, repair, and production needs.</h2>
            <p>
              Bring us a print, a failed component, a controls issue, or a time-sensitive
              replacement need. We will help define the practical next step and keep the
              communication clear from quote through delivery.
            </p>
          </div>
          <div className="capability-list" aria-label="Thermfection capabilities">
            {capabilities.map((capability) => (
              <span key={capability}>{capability}</span>
            ))}
          </div>
        </section>

        <section className="section-block process-section" aria-labelledby="process-title">
          <div className="section-heading">
            <p className="section-kicker">How We Work</p>
            <h2 id="process-title">Clear steps for urgent industrial work.</h2>
          </div>
          <div className="process-grid">
            {process.map((item) => (
              <article className="process-item" key={item.step}>
                <span>{item.step}</span>
                <h3>{item.title}</h3>
                <p>{item.copy}</p>
              </article>
            ))}
          </div>
        </section>

        <section className="contact-section" id="contact" aria-labelledby="contact-title">
          <div>
            <p className="section-kicker">Request a Quote</p>
            <h2 id="contact-title">Send the print, BOM, part number, or service issue.</h2>
          </div>
          <div className="contact-panel">
            <p>
              Thermfection is ready to review machining requirements, automation component
              lists, machine-down situations, and planned service work.
            </p>
            <a className="button button-primary" href="mailto:chris@thermfecion.com">
              Email Thermfection
            </a>
          </div>
        </section>
      </main>

      <footer className="site-footer">
        <img src={logoThermfection} alt="Thermfection" />
        <p>CNC machining | Industrial automation parts supply | Industrial service</p>
      </footer>
    </div>
  );
}

export default App;
